<template>
  <drag-modal :visible="visible"
              :loading="loading"
              width="4.5rem"
              @cancel="() => (visible = false)">
    <div class="flex-row justify-between align-center"
         slot="title">
      <div class="flex-row flex-1">
        <span class="font-bold trans-o-left"
              style="transform: scale(0.931944); font-size: 14px">{{ title }}{{ queryParam.Name }}</span>
      </div>
      <div>
        <span style="
            padding-right: 13.9792px;
            padding-left: 13.9792px;
            display: inline-block;
            transform: scale(0.815451);
            font-size:14px;
          ">
          今日报警 <span class="font-bold">{{ alarmCount }}</span> 次</span>
      </div>
    </div>
    <div>
      <div class="flex-column center"
           style="transform: scale(0.815451); font-size: 14px;margin-bottom: 14px;">
        <span v-if="data.DeviceStatus == 2"
              style="color: green">(在线)</span><span v-else
              style="color: red">(离线)</span>
        <div style="float: right">采集时间：{{ data.RecordTime }}</div>
      </div>
    </div>
    <div>
      <div class="align-center"
           v-if="data.Atmospheric"
           style="padding-left: 86px">
        <Echart :options="options"
                id="aqi"
                width="1.78rem"
                height="1.78rem"></Echart>
      </div>
      <div class="contaminant">
        <div class="flex-row">
          <div class="flex-fix">
            <span style="display: inline-block">温湿度</span>
            <span style="display: inline-block"></span>
          </div>
          <div class="flex-1">
            <span style="
                height: 1px;
                background: rgba(255, 255, 255, 0.3);
                width: 100%;
                display: inline-block;
              "></span>
          </div>
        </div>
        <div class="flex-row">
          <div class="grid-content">
            <div style="margin-bottom: 3.94074px">
              <img src="https://image.yingmen.co/uploader/image/g_qiwen.png"
                   style="
                transform: translateX(0.02rem);
                width: 0.25rem;
                height: 0.49rem;
              " />
            </div>

            <div v-if="data.Temperature"
                 style="margin: 2.81481px 0px">{{ data.Temperature }} ℃</div>
            <div v-if="!data.Temperature">--</div>
            <div v-else-if="data.Temperature <= -10">严寒</div>
            <div v-else-if="data.Temperature < 0">寒冷</div>
            <div v-else-if="data.Temperature < 10">凉爽</div>
            <div v-else-if="data.Temperature < 27">温暖</div>
            <div v-else-if="data.Temperature < 35">闷热</div>
            <div v-else-if="data.Temperature < 38">炎热</div>
            <div v-else>酷热</div>
          </div>
          <div class="grid-content">
            <div style="margin-bottom: 3.94074px">
              <img src="https://image.yingmen.co/uploader/image/g_wendu.png"
                   style="width: 0.45rem; height: 0.48rem" />
            </div>
            <div v-if="data.Humidity">{{ data.Humidity }} %</div>
            <div v-if="!data.Humidity">--</div>
            <div v-else-if="data.Temperature <= 30">干燥</div>
            <div v-else-if="data.Temperature <= 40">舒适干燥</div>
            <div v-else-if="data.Temperature < 50">轻微潮湿</div>
            <div v-else-if="data.Temperature < 60">偏潮湿</div>
            <div v-else-if="data.Temperature < 70">潮湿</div>
            <div v-else-if="data.Temperature < 80">较湿润</div>
            <div v-else>特别湿润</div>
          </div>
          <div class="grid-content">
            <div style="margin-bottom: 3.94074px">
              <img src="https://image.yingmen.co/uploader/image/g-pressure.png"
                   style="width: 0.48rem; height: 0.48rem" />
            </div>
            <div v-if="data.Pressure">{{ data.Pressure }}Pa</div>
            <div v-if="!data.Pressure">--</div>
            <div v-else-if="data.Pressure < 1.6">低压</div>
            <div v-else-if="data.Pressure < 10">中压</div>
            <div v-else-if="data.Pressure < 100">高压</div>
            <div v-else>超高压</div>
          </div>
        </div>
      </div>
      <div class="contaminant"
           v-if="data.PM25 || data.PM10 || data.TSP">
        <div class="flex-row">
          <div class="flex-fix">
            <span style="display: inline-block">污染物</span>
            <span style="display: inline-block">（μg/m³）</span>
          </div>
          <div class="flex-1">
            <span style="
                height: 1px;
                background: rgba(255, 255, 255, 0.3);
                width: 100%;
                display: inline-block;
              "></span>
          </div>
        </div>
        <div class="flex-row">
          <div class="grid-content">
            <div style="margin-bottom: 3.94074px">
              <img src="https://image.yingmen.co/uploader/image/g-pm25.png"
                   style="width: 0.48rem; height: 0.48rem" />
            </div>
            <div class="font-bold"
                 style="margin-bottom: 3.94074px">
              {{ data.PM25 }}
            </div>
            <div v-if="data.PM25 <= 0">--</div>
            <div v-else-if="data.PM25 < 35">优</div>
            <div v-else-if="data.PM25 < 75">良</div>
            <div v-else-if="data.PM25 < 115">轻度污染</div>
            <div v-else-if="data.PM25 < 150">中度污染</div>
            <div v-else-if="data.PM25 < 250">重度污染</div>
            <div v-else>严重污染</div>
          </div>
          <div class="grid-content">
            <div style="margin-bottom: 3.94074px">
              <img src="https://image.yingmen.co/uploader/image/g-pm10.png"
                   style="width: 0.48rem; height: 0.48rem" />
            </div>
            <div class="font-bold"
                 style="margin-bottom: 3.94074px">
              {{ data.PM10 }}
            </div>
            <div v-if="data.PM10 <= 0">--</div>
            <div v-else-if="data.PM10 < 50">优</div>
            <div v-else-if="data.PM10 < 100">良</div>
            <div v-else-if="data.PM10 < 150">轻度污染</div>
            <div v-else-if="data.PM10 < 200">中度污染</div>
            <div v-else-if="data.PM10 < 250">重度污染</div>
            <div v-else>严重污染</div>
          </div>
          <div class="grid-content">
            <div style="margin-bottom: 3.94074px">
              <img src="https://image.yingmen.co/uploader/image/g-tsp.png"
                   style="width: 0.48rem; height: 0.48rem" />
            </div>
            <div class="font-bold"
                 style="margin-bottom: 3.94074px">
              {{ data.TSP }}
            </div>
            <div v-if="data.TSP <= 0">--</div>
            <div v-else-if="data.TSP < 50">优</div>
            <div v-else-if="data.TSP < 100">良</div>
            <div v-else-if="data.TSP < 150">轻度污染</div>
            <div v-else-if="data.TSP < 200">中度污染</div>
            <div v-else-if="data.TSP < 250">重度污染</div>
            <div v-else>严重污染</div>
          </div>
        </div>
      </div>
      <div class="contaminant"
           v-if="data.Noise || data.WindSpeed">
        <div class="flex-row">
          <div class="flex-fix">
            <span style="display: inline-block">噪音/气压</span>
          </div>
          <div class="flex-1">
            <span style="
                height: 1px;
                background: rgba(255, 255, 255, 0.3);
                width: 100%;
                display: inline-block;
              "></span>
          </div>
        </div>

        <div class="flex-row">
          <div class="grid-content">
            <div style="margin-bottom: 3.94074px">
              <img src="https://image.yingmen.co/uploader/image/g-noise.png"
                   style="width: 0.48rem; height: 0.48rem" />
            </div>
            <div v-if="data.Noise && data.Noise > 0"
                 style="margin: 2.81481px 0px">{{ data.Noise }} db</div>
            <div v-if="data.Noise <= 0">--</div>
            <div v-else-if="data.Noise < 50">好</div>
            <div v-else-if="data.Noise < 55">较好</div>
            <div v-else-if="data.Noise < 60">轻度污染</div>
            <div v-else-if="data.Noise < 65">中度污染</div>
            <div v-else>重度污染</div>
          </div>
          <div class="grid-content">
            <div style="margin-bottom: 3.94074px">
              <img src="https://image.yingmen.co/uploader/image/g_fengsu.png"
                   style="width: 0.48rem; height: 0.48rem" />
            </div>
            <div v-if="data.WindSpeed">{{ data.WindSpeed }} m/s <span>{{ data.DirectionText }}</span></div>
            <div v-if="!data.WindSpeed">--</div>
            <div v-else-if="data.WindSpeed <= 0.2">无风</div>
            <div v-else-if="data.WindLevel <= 1.5">软风</div>
            <div v-else-if="data.WindLevel <= 3.3">清风</div>
            <div v-else-if="data.WindLevel <=5.5 ">微风</div>
            <div v-else-if="data.WindLevel <= 7.9">和风</div>
            <div v-else-if="data.WindLevel <= 10.7">劲风</div>
            <div v-else-if="data.WindLevel <=13.8 ">强风</div>
            <div v-else-if="data.WindLevel <=17.1">疾风</div>
            <div v-else-if="data.WindLevel <= 20.7">大风</div>
            <div v-else-if="data.WindLevel <= 24.4">烈风</div>
            <div v-else-if="data.WindLevel <= 28.4">狂风</div>
            <div v-else-if="data.WindLevel < 32.6">暴风</div>
            <div v-else>飓风</div>
          </div>
        </div>
      </div>

      <div class="contaminant"
           v-if="data.Gas">
        <div class="flex-row">
          <div class="flex-fix">
            <span style="display: inline-block">气体监测</span>
          </div>
          <div class="flex-1">
            <span style="
                height: 1px;
                background: rgba(255, 255, 255, 0.3);
                width: 100%;
                display: inline-block;
              "></span>
          </div>
        </div>

        <div class="flex-row"
             style="display: flex;flex-wrap: wrap;">
          <template v-for="(item) in data.Gas">
            <div class="grid-content"
                 v-if="item.Potency > 0 ||((item.MonitorProjectKey === 'h2s' || item.MonitorProjectKey === 'co' || item.MonitorProjectKey === 'ch4'))"
                 v-bind:potency="item.Potency"
                 v-bind:id="item.Id"
                 v-bind:key="item.Id"
                 v-bind:name="item.Name">
              <div style="margin-bottom: 3.94074px">
                <img v-bind:src="`https://image.yingmen.co/uploader/image/g-` + item.MonitorProjectKey + `.png`"
                     style="width: 0.48rem; height: 0.48rem" />
              </div>
              <div style="margin: 2.81481px 0px">{{ item.Potency }} ppm</div>
              <div v-if="data.Potency <= 0">--</div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </drag-modal>
</template>
<script>
import DragModal from "@/components/DragModal";
import Echart from "@/common/echart";
export default {
  data () {
    return {
      loading: true,
      visible: false,
      title: "",
      alarmCount: 0,
      data: {},
      options: {},
      queryParam: {},
    };
  },
  components: {
    DragModal,
    Echart,
  },
  watch: {
    data (newData) {
      let upPressure = newData.Atmospheric;
      let name = "AQI";
      this.options = {
        tooltip: {
          formatter: " {c}ug/m³",
        },
        series: [
          {
            name: name,
            type: "gauge",
            //center: ["50%", "45%"], // 默认全局居中
            min: 0,
            max: 500,
            detail: {
              formatter: "{value}",
              offsetCenter: [0, 0],
              color: "#fff",
            },
            title: {
              offsetCenter: [0, "68%"], // x, y，单位px
              fontWeight: "bolder",
              fontSize: 15,
              fontStyle: "italic",
              color: "#fff",
              shadowColor: "#fff", //默认透明
              shadowBlur: 10,
            },
            data: [{ value: upPressure, name: name }],
            clockwise: true,
            radius: "90%",
            axisLabel: {
              // 刻度标签。
              show: false,
              distance: -5,
              color: "white",
              fontSize: 10,
              formatter: "{value}",
            },
            splitLine: { show: false },
            axisLine: {
              // 仪表盘轴线(轮廓线)相关配置。
              show: true,
              lineStyle: {
                // 仪表盘轴线样式。
                opacity: 1,
                width: 10,
                shadowBlur: 50,
                color: [
                  [upPressure / 500, "green"],
                  [1, "gray"],
                ],
              },
            },
            pointer: {
              // 仪表盘指针。
              show: true,
              length: "70%",
              width: 2,
            },
          },
        ],
      };
    },
  },
  methods: {
    openForm (device) {
      console.log(device);
      this.title = device.DeviceMethodStr;
      this.queryParam = {
        ProId: device.ProId,
        Name: device.Name,
        DeviceId: device.Id,
        Code: device.Code
      };
      this.loading = false;
      this.visible = true;
      this.init();
    },
    init () {
      this.loading = true;
      this.$http
        .post("/DeviceManage/DeviceEnv/GetEnvLastRecord", this.queryParam)
        .then((resJson) => {
          this.loading = false;
          this.data = resJson.Data;
          console.log(resJson);
        });
    },
  },
};
</script>
<style scoped>
.flex-row {
  margin-bottom: 10px;
}
.align-center {
  align-items: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  text-align: center;
}
.device-list li {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
}
.grid-content {
  text-align: center;
  width: 33.33%;
}
</style>